module.exports = __webpack_public_path__ + "media/icons/link-mail-4ba60ad7.png";